//**auto-generated don't edit this code**//
export enum FilterScope {
	AllTests,
	MyTests,
	DistrictTests,
	DraftTests,
	Favorites,
}